/**
 * A distinct, evenly-spread hue for series `i` of `n` — so an org with many
 * domains still gets legible, separable lines. Fixed saturation/lightness
 * read acceptably in both light and dark themes (charts sit on a neutral plot).
 */
export function seriesColor(i: number, n: number): string {
  const hue = Math.round((i * 360) / Math.max(n, 1));
  return `hsl(${hue} 62% 55%)`;
}
